// Razorpay Configuration
export const RAZORPAY_CONFIG = {
  
  // Currency
  DEFAULT_CURRENCY: 'INR',
  
  // Return URLs
  RETURN_URL: window.location.origin + '/payment-return',
  CANCEL_URL: window.location.origin + '/pricing',
  
  // Branding
  BRAND_NAME: 'EmailValidator',
  BRAND_COLOR: '#00d68f',
  
  // Supported Currencies
  SUPPORTED_CURRENCIES: [
    { code: 'INR', symbol: '₹', name: 'Indian Rupee' },
    { code: 'USD', symbol: '$', name: 'US Dollar' },
    { code: 'EUR', symbol: '€', name: 'Euro' },
    { code: 'GBP', symbol: '£', name: 'British Pound' },
    { code: 'CAD', symbol: 'C$', name: 'Canadian Dollar' },
    { code: 'AUD', symbol: 'A$', name: 'Australian Dollar' },
    { code: 'SGD', symbol: 'S$', name: 'Singapore Dollar' },
    { code: 'AED', symbol: 'د.إ', name: 'UAE Dirham' },
  ]
};

export default RAZORPAY_CONFIG; 